import React, { createContext, ReactNode, useContext } from 'react';
import { Skeleton } from 'src/components/ui';

const FormLoadingContext = createContext(false);

/** Marks everything inside as still loading: kit controls render a placeholder in place of their input. */
export function FormLoadingProvider({ loading, children }: { loading: boolean; children: ReactNode }) {
  return <FormLoadingContext.Provider value={loading}>{children}</FormLoadingContext.Provider>;
}

/** True while the record behind the surrounding editor is still loading. */
export function useFormLoading(): boolean {
  return useContext(FormLoadingContext);
}

/** Stand-in for an input or select, the same height as the real control so nothing shifts when it arrives. */
export function ControlSkeleton({ width = '100%' }: { width?: string }) {
  return <Skeleton width={width} height="2.375rem" rounded="md" />;
}

export default FormLoadingProvider;
